import classNames from 'classnames'
import Image from 'next/image'
import React, { FunctionComponent } from 'react'
import orderSummaryStyles from '../OrderSummary/OrderSummary.module.css'
import lineItemsStyles from '../LineItems/LineItems.module.css'
import styles from './LocationWithAddress.module.css'
import TXT from '@/messages'
import { buildMapUrl } from '@/utils/urls.utils'

const { titles: { components: { locationWithAddress: locationTitle } } } = TXT
type Props = {
  title: string
  address: Nullable<string>
}

const LocationWithAddress: FunctionComponent<Props> = ({ title, address }:Props) => (
  <>
    <h1 className={classNames(
      orderSummaryStyles.GeneralTitle,
      orderSummaryStyles.MinorTitle,
      styles.LocationTitle,
    )}
    >
      {locationTitle}
    </h1>
    <h1 className={lineItemsStyles.TicketCategoryTitle}>{title}</h1>
    {address && (
      <address className={styles.Address}>
        <a
          className={styles.AddressLink}
          target="_blank"
          href={buildMapUrl(address)}
          rel="noreferrer"
          title={TXT.eventsA11y.addressText}
        >
          <Image height={20} width={20} src="/static/events/svg/location-pin.svg" alt={TXT.eventsA11y.venueLocation(address)} />
          {address}
        </a>
      </address>
    )}

    <hr className="separator dark" data-location-separator />
  </>
)
export default LocationWithAddress
